import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.name, 'name'));
    Object.assign(errors, validators.maxLength({value: values.name, maxLength: 100}, 'name'));
    Object.assign(errors, validators.maxLength({value: values.description, maxLength: 500}, 'description'));
    Object.assign(errors, validators.required(values.encoding_job_profile, 'encoding_job_profile'));

    if (!values.is_placeholder_for_auto_assignment) {
        Object.assign(errors, validators.required(values.vtd_tunnel_id, 'vtd_tunnel_id'));
    }

    return errors;
};

export default validate;
